<app-dialog
  [header]="'Request Specific Deal'"
  [modal]="true"
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [style]="{ width: '512px' }"
>
  <div class="flex flex-col gap-5">
    <div class="flex items-start gap-2">
      <img src="/icons/briefcase-deal.svg" alt="Deal" class="w-4 h-4 mt-1" />
      <p class="text-label-medium-large-r font-bold m-0" style="color: var(--deepteal-500);">
        <span class="whitespace-nowrap">Is there a specific company or asset you are looking to invest in?</span>
        <span class="block text-muted-color font-normal">Please provide info here</span>
      </p>
    </div>

    <form [formGroup]="requestDealForm" class="flex flex-col items-start gap-5 w-full" (ngSubmit)="submitRequest()">
      <!-- Deal Name -->
      <div class="flex flex-col gap-1 w-full">
        <label class="font-medium text-sm text-headingText" for="dealName">Deal Name (if known)</label>
        <input
          id="dealName"
          pInputText
          formControlName="name"
          type="text"
          pSize="large"
          class="p-inputtext w-full"
        />
      </div>

      <div class="w-full flex items-center gap-3">
        <span class="flex-1 border-t border-border"></span>
        <span class="text-sm text-muted-color">OR</span>
        <span class="flex-1 border-t border-border"></span>
      </div>

      <div class="w-full">
        <div class="flex items-start gap-2">
          <img src="/icons/target.svg" alt="Asset Exposure" class="w-4 h-4 mt-1" />
          <p class="text-label-medium-r font-bold mb-0" style="color: var(--deepteal-500);">
            Is there a specific asset class that you are looking for exposure to?
            <span class="block text-muted-color font-normal">Please provide info here</span>
          </p>
        </div>
        @if (showDealCriteriaError) {
          <small class="text-error">Please provide Deal Name or Asset Class details</small>
        }
      </div>
      
      <!-- Asset Class -->
      <div class="flex flex-col gap-1 w-full">
        <label class="font-medium text-sm text-headingText" for="assetClass">Asset Class</label>
        <p-select
          id="assetClass"
          formControlName="assetClass"
          [options]="assetClasses"
          optionLabel="labelKey"
          optionValue="value"
          placeholder="Please select"
          styleClass="w-full"
          [fluid]="true"
          appendTo="body"
        >
          <ng-template #selectedItem let-selectedOption>
            {{ selectedOption?.labelKey | translate }}
          </ng-template>
          <ng-template let-option #item>
            {{ option.labelKey | translate }}
          </ng-template>
        </p-select>
      </div>

      <!-- Sub-Asset Class -->
      <div class="flex flex-col gap-1 w-full">
        <label class="font-medium text-sm text-headingText" for="assetSubClass">Sub-Asset Class</label>
        <p-select
          id="assetSubClass"
          formControlName="assetSubClass"
          [options]="filteredAssetSubClasses"
          optionLabel="labelKey"
          optionValue="value"
          placeholder="Please select"
          styleClass="w-full"
          [disabled]="requestDealForm.get('assetClass')?.value == null"
          [fluid]="true"
          appendTo="body"
        >
          <ng-template #selectedItem let-selectedOption>
            {{ selectedOption?.labelKey | translate }}
          </ng-template>
          <ng-template let-option #item>
            {{ option.labelKey | translate }}
          </ng-template>
        </p-select>
        @if (requestDealForm.get('assetSubClass')?.invalid && requestDealForm.get('assetSubClass')?.touched) {
          <small class="text-error">Sub-Asset Class is required</small>
        }
      </div>

      <!-- Investment Amount -->
      <div class="flex flex-col gap-1 w-full">
        <label class="font-medium text-sm text-headingText" for="investmentAmount">Investment Amount ($)</label>
        <p-select
          id="investmentAmount"
          formControlName="investmentAmountRange"
          [options]="investmentAmountRangeOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Please select"
          styleClass="w-full"
          [fluid]="true"
          appendTo="body"
        />
        @if (requestDealForm.get('investmentAmountRange')?.invalid && requestDealForm.get('investmentAmountRange')?.touched) {
          <small class="text-error">Investment Amount is required</small>
        }
      </div>

      <!-- Investment Deadline Date -->
      <div class="flex flex-col gap-1 w-full">
        <label class="font-medium text-sm text-headingText">Ideal Investment Timing</label>
        <div class="flex flex-col gap-3">
          @for (timingOption of investmentTimingOptions; track timingOption.value) {
            <div class="flex items-center gap-2">
              <p-radiobutton
                [inputId]="'timing-' + timingOption.value"
                formControlName="targetInvestmentTime"
                [value]="timingOption.value"
                name="targetInvestmentTime"
              />
              <label class="text-sm text-headingText cursor-pointer" [for]="'timing-' + timingOption.value">
                {{ timingOption.label }}
              </label>
            </div>
          }
        </div>
        @if (requestDealForm.get('targetInvestmentTime')?.invalid && requestDealForm.get('targetInvestmentTime')?.touched) {
          <small class="text-error">Ideal Investment Timing is required</small>
        }
      </div>

      <!-- Comments -->
      <div class="flex flex-col gap-1 w-full">
        <label class="font-medium text-sm text-headingText" for="otherComments">Comments</label>
        <app-input
          type="textarea"
          id="otherComments"
          name="otherComments"
          formControlName="otherComments"
          placeholder="Comments..."
          [rows]="5"
          [fluid]="true"
        />
        @if (requestDealForm.get('otherComments')?.invalid && requestDealForm.get('otherComments')?.touched) {
          <small class="text-error">Please enter your comments</small>
        }
      </div>

      <!-- Actions -->
      <div class="w-full">
        <app-button
          type="submit"
          variant="primary"
          label="Send"
          endIcon="/icons/send.svg"
          [fluid]="true"
          [loading]="isSubmitting()"
        />
      </div>
    </form>
  </div>
</app-dialog>
